<template>
  <div class="pay-new">
    <!-- 顶部导航栏 -->
    <div class="nav-header">
      <van-nav-bar 
        title="订单支付" 
        left-arrow 
        @click-left="goBack"
        :border="false"
      >
        <template #title>
          <div class="nav-title">
            <i class="title-icon">💳</i>
            <span>订单支付</span>
          </div>
        </template>
      </van-nav-bar>
    </div>

    <div class="main-content">
      <!-- 支付金额显示 -->
      <div class="amount-display">
        <div class="amount-card">
          <div class="amount-icon">
            <i class="money-icon">💰</i>
          </div>
          <div class="amount-info">
            <div class="amount-label">支付金额</div>
            <div class="amount-value">¥{{ cost }}</div>
          </div>
          <div class="amount-decoration">
            <div class="decoration-circle"></div>
            <div class="decoration-line"></div>
          </div>
        </div>
      </div>

      <!-- 订单信息票据 -->
      <div class="order-ticket">
        <div class="ticket-header">
          <div class="ticket-title">
            <i class="ticket-icon">🎫</i>
            <span>订单信息</span>
          </div>
          <div class="ticket-number">
            <span>No. {{ formatOrderNo(orderNo) }}</span>
          </div>
        </div>
        
        <div class="ticket-content">
          <div class="info-grid">
            <div class="info-item">
              <div class="info-icon">📱</div>
              <div class="info-details">
                <div class="info-label">联系电话</div>
                <div class="info-value">{{ formatPhone(phone) }}</div>
              </div>
            </div>
            
            <div class="info-item">
              <div class="info-icon">🆔</div>
              <div class="info-details">
                <div class="info-label">订单编号</div>
                <div class="info-value">{{ orderNo }}</div>
              </div>
            </div>
            
            <div class="info-item">
              <div class="info-icon">⏰</div>
              <div class="info-details">
                <div class="info-label">下单时间</div>
                <div class="info-value">{{ getCurrentTime() }}</div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 票据虚线分割 -->
        <div class="ticket-divider">
          <div class="perforation"></div>
        </div>
        
        <div class="ticket-footer">
          <div class="security-notice">
            <div class="notice-icon">
              <i class="shield-icon">🛡️</i>
            </div>
            <div class="notice-text">
              <div class="notice-title">安全提示</div>
              <div class="notice-content">为保证安全，请您对付款信息确认无误后再支付</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 支付方式选择 -->
      <!-- <div class="payment-methods">
        <div class="methods-title">
          <i class="methods-icon">💎</i>
          <h3>支付方式</h3>
        </div>
        
        <div class="method-card" :class="{ active: selectedMethod === 'unionpay' }" @click="selectMethod('unionpay')">
          <div class="method-icon">
            <i class="union-icon">🏦</i>
          </div>
          <div class="method-info">
            <div class="method-name">银联支付</div>
            <div class="method-desc">支持各大银行卡</div>
          </div>
          <div class="method-check">
            <van-icon :name="selectedMethod === 'unionpay' ? 'checked' : 'circle'" :color="selectedMethod === 'unionpay' ? '#1989fa' : '#dcdee0'" />
          </div>
        </div>
      </div> -->

      <!-- 支付协议 -->
      <!-- <div class="payment-agreement">
        <div class="agreement-checkbox" @click="toggleAgreement">
          <van-icon :name="agreedToTerms ? 'checked' : 'circle'" :color="agreedToTerms ? '#1989fa' : '#dcdee0'" />
          <span class="agreement-text">
            我已阅读并同意
            <span class="agreement-link">《支付服务协议》</span>
            和
            <span class="agreement-link">《隐私政策》</span>
          </span>
        </div>
      </div> -->
    </div>

    <!-- 底部支付按钮 -->
    <div class="payment-footer">
      <div class="payment-summary">
        <div class="summary-left">
          <div class="total-label">应付金额</div>
          <div class="total-amount">¥{{ cost }}</div>
        </div>
        <div class="pay-button" @click="handlePay" :class="{ disabled: !canPay, loading: isProcessing }">
          <div class="button-content">
            <van-loading v-if="isProcessing" size="20px" color="white" />
            <i v-else class="pay-icon">💳</i>
            <span>{{ isProcessing ? '支付中...' : '立即支付' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付处理弹窗 -->
    <van-dialog
      v-model="showPayDialog"
      title="正在跳转支付"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
    >
      <div class="pay-dialog-content">
        <van-loading size="30px" color="#1989fa" />
        <p>正在为您跳转到支付页面...</p>
        <p class="dialog-tip">请在新页面完成支付</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import qs from 'qs';

export default {
  name: 'PayNew',
  data() {
    return {
      cost: 0,
      phone: '',
      orderNo: '',
      selectedMethod: 'unionpay',
      agreedToTerms: true,
      isProcessing: false,
      showPayDialog: false
    }
  },
  
  computed: {
    canPay() {
      return this.agreedToTerms && this.selectedMethod && !this.isProcessing;
    }
  },
  
  mounted() {
    this.initPaymentData();
  },
  
  methods: {
    // 初始化支付数据
    initPaymentData() {
      this.phone = this.$route.query.phone || '';
      this.orderNo = this.$route.query.orderNo || '';
      this.cost = this.$route.query.cost || 0;
    },
    
    // 返回上一页
    goBack() {
      this.$router.back();
    },
    
    // 格式化订单号显示
    formatOrderNo(orderNo) {
      if (!orderNo) return '';
      return orderNo.length > 12 ? orderNo.substr(0, 6) + '...' + orderNo.substr(-6) : orderNo;
    },
    
    // 格式化手机号
    formatPhone(phone) {
      if (!phone) return '';
      return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');
    },
    
    // 获取当前时间
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const hour = now.getHours().toString().padStart(2, '0');
      const minute = now.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    
    // 选择支付方式
    selectMethod(method) {
      this.selectedMethod = method;
    },
    
    // 切换协议同意状态
    toggleAgreement() {
      this.agreedToTerms = !this.agreedToTerms;
    },
    
    // 处理支付
    handlePay() {
      if (!this.canPay) {
        if (!this.agreedToTerms) {
          this.$toast('请先同意支付协议');
        }
        return;
      }
      
      this.isProcessing = true;
      this.showPayDialog = true;
      
      // 调用支付接口
      this.processPayment();
    },
    
    // 处理支付逻辑
    processPayment() {
      let baseUrl = window.location.origin;
      let successUrl = baseUrl + '/paySuccess';
      
      this.request({
        url: `/order/h5/allinpay/pay?orderNo=${this.orderNo}&orderType=1&url=${successUrl}`,
        method: 'GET'
      }).then(res => {
        console.log('支付返回结果', res);
        this.isProcessing = false;
        this.showPayDialog = false;
        
        // 跳转到银联支付页面
        const paymentUrl = `https://syb.allinpay.com/apiweb/h5unionpay/unionorder?${qs.stringify(res)}`;
        window.location.href = paymentUrl;
        
      }).catch(error => {
        console.error('支付失败:', error);
        this.isProcessing = false;
        this.showPayDialog = false;
        this.$toast('支付失败，请重试');
      });
    }
  }
}
</script>

<style lang="less" scoped>
.pay-new {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  
  .nav-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    
    .van-nav-bar {
      background: transparent;
      
      .nav-title {
        display: flex;
        align-items: center;
        gap: 8px;
        
        .title-icon {
          font-size: 20px;
        }
      }
    }
  }
  
  .main-content {
    padding: 20px 15px 100px;
    
    // 支付金额显示
    .amount-display {
      margin-bottom: 20px;
      
      .amount-card {
        background: rgba(255, 255, 255, 0.95);
        border-radius: 20px;
        padding: 30px 20px;
        backdrop-filter: blur(10px);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        position: relative;
        overflow: hidden;
        animation: slideInDown 0.6s ease-out;
        
        .amount-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;
          
          .money-icon {
            font-size: 28px;
          }
        }
        
        .amount-info {
          flex: 1;
          
          .amount-label {
            font-size: 14px;
            color: #7f8c8d;
            margin-bottom: 8px;
          }
          
          .amount-value {
            font-size: 32px;
            font-weight: 600;
            color: #e74c3c;
          }
        }
        
        .amount-decoration {
          position: absolute;
          right: -30px;
          top: -30px;
          
          .decoration-circle {
            width: 80px;
            height: 80px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 50%;
            opacity: 0.1;
          }
          
          .decoration-line {
            position: absolute;
            top: 40px;
            left: -50px;
            width: 100px;
            height: 2px;
            background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
            opacity: 0.3;
          }
        }
      }
    }
    
    // 订单信息票据
    .order-ticket {
      background: rgba(255, 255, 255, 0.95);
      border-radius: 20px;
      margin-bottom: 20px;
      backdrop-filter: blur(10px);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      animation: slideInUp 0.6s ease-out;
      
      .ticket-header {
        background: linear-gradient(135deg, #1989fa 0%, #0984e3 100%);
        color: white;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .ticket-title {
          display: flex;
          align-items: center;
          gap: 8px;
          
          .ticket-icon {
            font-size: 18px;
          }
          
          span {
            font-size: 16px;
            font-weight: 600;
          }
        }
        
        .ticket-number {
          font-size: 12px;
          opacity: 0.9;
        }
      }
      
      .ticket-content {
        padding: 24px 20px;
        
        .info-grid {
          display: grid;
          gap: 20px;
          
          .info-item {
            display: flex;
            align-items: center;
            gap: 12px;
            
            .info-icon {
              width: 40px;
              height: 40px;
              background: rgba(25, 137, 250, 0.1);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;
            }
            
            .info-details {
              flex: 1;
              
              .info-label {
                font-size: 12px;
                color: #7f8c8d;
                margin-bottom: 4px;
              }
              
              .info-value {
                font-size: 14px;
                color: #2c3e50;
                font-weight: 500;
                word-break: break-all;
              }
            }
          }
        }
      }
      
      .ticket-divider {
        height: 20px;
        background: #f8f9fa;
        position: relative;
        
        .perforation {
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 2px;
          background: repeating-linear-gradient(
            90deg,
            transparent,
            transparent 5px,
            #ddd 5px,
            #ddd 10px
          );
          transform: translateY(-50%);
        }
        
        &::before,
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          width: 20px;
          height: 20px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 50%;
          transform: translateY(-50%);
        }
        
        &::before {
          left: -10px;
        }
        
        &::after {
          right: -10px;
        }
      }
      
      .ticket-footer {
        padding: 20px;
        
        .security-notice {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          
          .notice-icon {
            width: 40px;
            height: 40px;
            background: rgba(39, 174, 96, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            
            .shield-icon {
              font-size: 16px;
            }
          }
          
          .notice-text {
            flex: 1;
            
            .notice-title {
              font-size: 14px;
              font-weight: 600;
              color: #27ae60;
              margin-bottom: 4px;
            }
            
            .notice-content {
              font-size: 12px;
              color: #7f8c8d;
              line-height: 1.4;
            }
          }
        }
      }
    }
    
    // 支付方式
    .payment-methods {
      margin-bottom: 20px;
      
      .methods-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        
        .methods-icon {
          font-size: 20px;
        }
        
        h3 {
          color: white;
          font-size: 18px;
          font-weight: 600;
        }
      }
      
      .method-card {
        background: rgba(255, 255, 255, 0.95);
        border-radius: 16px;
        padding: 20px;
        display: flex;
        align-items: center;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        animation: slideInLeft 0.6s ease-out;
        cursor: pointer;
        
        &.active {
          background: rgba(25, 137, 250, 0.1);
          border: 2px solid #1989fa;
        }
        
        .method-icon {
          width: 48px;
          height: 48px;
          background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          
          .union-icon {
            font-size: 20px;
            color: white;
          }
        }
        
        .method-info {
          flex: 1;
          
          .method-name {
            font-size: 16px;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 4px;
          }
          
          .method-desc {
            font-size: 12px;
            color: #7f8c8d;
          }
        }
        
        .method-check {
          .van-icon {
            font-size: 20px;
          }
        }
      }
    }
    
    // 支付协议
    .payment-agreement {
      .agreement-checkbox {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        cursor: pointer;
        
        .van-icon {
          margin-top: 2px;
        }
        
        .agreement-text {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.4;
          
          .agreement-link {
            color: #1989fa;
            text-decoration: underline;
          }
        }
      }
    }
  }
  
  // 底部支付区域
  .payment-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    padding: 16px 20px;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
    
    .payment-summary {
      display: flex;
      align-items: center;
      gap: 16px;
      
      .summary-left {
        flex: 1;
        
        .total-label {
          font-size: 14px;
          color: #7f8c8d;
          margin-bottom: 4px;
        }
        
        .total-amount {
          font-size: 24px;
          font-weight: 600;
          color: #e74c3c;
        }
      }
      
      .pay-button {
        background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
        color: white;
        padding: 14px 32px;
        border-radius: 25px;
        cursor: pointer;
        transition: all 0.3s ease;
        min-width: 140px;
        
        &:hover:not(.disabled):not(.loading) {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(39, 174, 96, 0.3);
        }
        
        &.disabled {
          background: #bdc3c7;
          cursor: not-allowed;
          
          &:hover {
            transform: none;
            box-shadow: none;
          }
        }
        
        &.loading {
          background: #3498db;
          cursor: not-allowed;
        }
        
        .button-content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          
          .pay-icon {
            font-size: 18px;
          }
          
          span {
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
    }
  }
  
  // 支付弹窗内容
  .pay-dialog-content {
    padding: 20px;
    text-align: center;
    
    p {
      margin: 16px 0 8px;
      font-size: 14px;
      color: #2c3e50;
    }
    
    .dialog-tip {
      font-size: 12px;
      color: #7f8c8d;
    }
  }
}

// 动画
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style> 